var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FEE5F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15C14.888 15 14.0614 15.3424 13.4519 15.9519C12.8424 16.5614 12.5 17.388 12.5 18.25V19.5H32.5V18.25C32.5 17.8232 32.4159 17.4006 32.2526 17.0063C32.0893 16.612 31.8499 16.2537 31.5481 15.9519C31.2463 15.6501 30.888 15.4107 30.4937 15.2474C30.0994 15.0841 29.6768 15 29.25 15H15.75ZM32.5 21H12.5V25.75C12.5 26.612 12.8424 27.4386 13.4519 28.0481C14.0614 28.6576 14.888 29 15.75 29H29.25C29.6768 29 30.0994 28.9159 30.4937 28.7526C30.888 28.5893 31.2463 28.3499 31.5481 28.0481C31.8499 27.7463 32.0893 27.388 32.2526 26.9937C32.4159 26.5994 32.5 26.1768 32.5 25.75V21ZM26.25 24.5H28.75C28.9489 24.5 29.1397 24.579 29.2803 24.7197C29.421 24.8603 29.5 25.0511 29.5 25.25C29.5 25.4489 29.421 25.6397 29.2803 25.7803C29.1397 25.921 28.9489 26 28.75 26H26.25C26.0511 26 25.8603 25.921 25.7197 25.7803C25.579 25.6397 25.5 25.4489 25.5 25.25C25.5 25.0511 25.579 24.8603 25.7197 24.7197C25.8603 24.579 26.0511 24.5 26.25 24.5Z",
    fill: "#F01272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentActive);
export default __webpack_public_path__ + "static/media/paymentActive.36c2a3f9a6814c5d3e5f0a66fd4e0808.svg";
export { ForwardRef as ReactComponent };